var map = {
	"./about.png": 8104,
	"./blossom-2.png": 9077,
	"./blossom.png": 8544,
	"./gallery.png": 8557,
	"./lock.png": 3618,
	"./photography-2.jpg": 4367,
	"./photography-3.jpg": 8050,
	"./photography.jpg": 6762,
	"./sas.png": 1572,
	"./sx.png": 5982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1799;